import { useState } from "react";
import { Ellipsis, Pencil, Trash2 } from "lucide-react";
import { toast } from "sonner";

import ACL_RELATIONSHIPS from "acl-relationships";
import { buttonVariants } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import Authorized from "components/Authorized";
import ConfirmDeleteDialog from "components/modals/ConfirmDeleteDialog";
import FormDialog from "components/modals/FormDialog";
import { invalidateInvestigationStatusesTableQuery } from "hooks/useInvestigationStatusesTable";
import InvestigationStatusForm from "routes/investigation_status/components/InvestigationStatusForm";
import InvestigationStatusService from "services/InvestigationStatus";

const EDIT_ACLS = [ACL_RELATIONSHIPS.investigationStatus.edit];
const DELETE_ACLS = [ACL_RELATIONSHIPS.investigationStatus.delete];
const ANY_ACLS = [...EDIT_ACLS, ...DELETE_ACLS];

export function InvestigationStatusesTableActions({ original }) {
  const [editOpen, setEditOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);

  const handleDelete = async () => {
    try {
      await InvestigationStatusService.deleteInvestigationStatus(original.id);
      toast.success("Investigation Status deleted");
      setDeleteOpen(false);
      await invalidateInvestigationStatusesTableQuery();
    } catch {
      toast.error("Failed to delete Investigation Status");
    }
  };

  return (
    <Authorized permissions={ANY_ACLS} partialMatch>
      <>
        <DropdownMenu>
          <DropdownMenuTrigger
            aria-label="Investigation status actions"
            className={buttonVariants({ variant: "ghost", size: "icon-sm" })}
          >
            <Ellipsis />
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            <Authorized permissions={EDIT_ACLS}>
              <DropdownMenuItem onClick={() => setEditOpen(true)}>
                <Pencil />
                Edit
              </DropdownMenuItem>
            </Authorized>
            <Authorized permissions={DELETE_ACLS}>
              <DropdownMenuItem
                variant="destructive"
                onClick={() => setDeleteOpen(true)}
              >
                <Trash2 />
                Delete
              </DropdownMenuItem>
            </Authorized>
          </DropdownMenuContent>
        </DropdownMenu>
        <FormDialog
          FormComponent={InvestigationStatusForm}
          model={original}
          modelType="Investigation Status"
          open={editOpen}
          onOpenChange={setEditOpen}
          onSuccess={invalidateInvestigationStatusesTableQuery}
        />
        <ConfirmDeleteDialog
          open={deleteOpen}
          onOpenChange={setDeleteOpen}
          title="Delete Investigation Status?"
          description="Are you sure you want to delete this Investigation Status?"
          onConfirm={handleDelete}
        />
      </>
    </Authorized>
  );
}
